import { Component } from '@angular/core';

@Component({
  selector: 'app-gamification-skeleton',
  templateUrl: './gamification-skeleton.component.html',
  styleUrls: ['./gamification-skeleton.component.scss'],
})
export class GamificationSkeletonComponent {
}
